<template>
  <section class="container" ref="detailContainer">
    <slot name="default"></slot>
    <h1 class="title">
      {{title}}
      <!--span class="date">更新日期：{{moment(operationTimestamp)}}</span-->
      <!--button class="download cursor-pointer" @click="download1()" v-if="pdfUrl">下载</button-->
      <a :href="pdfUrl" target="_blank" title="下载" class="btn-download" v-if="pdfUrl">下载</a>
    </h1>
    <div class="content">
      <view-container :loading="loading" :empty="empty" :error="error" :noPermission="!hasPermission" @retry="loadData">
        <div class="info" v-html="htmlMainBody"></div>
      </view-container>
    </div>
  </section>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import moment from 'moment'
import viewContainer from '@/components/viewContainer'
import html2canvas from 'html2canvas'
import jsPDF from "jspdf"
export default {
  name: 'DetailContent',
  data () {
    return {
      loading: false,
      empty: false,
      error: false,
      downloadIng: false
    }
  },
  computed: {
    ...mapState('rule', ['getChildrenFn']),
    ...mapState('detail', ['title', 'operationTimestamp', 'htmlMainBody', 'hasPermission', 'pdfUrl']),
  },
  async mounted () {
    this.mountedFn()
  },
  methods: {
    mountedFn () {
      const ruleId = this.$route.query.ruleId
      this.updateRuleId(ruleId)
      this.loadData()
    },
    ...mapMutations({
      updateCategoryId: 'updateCategoryId',
      updateRuleId: 'detail/updateRuleId'
    }),
    ...mapActions('detail', ['getRuleDetail']),
    loadData () {
      this.loading = true
      this.error = false
      this.getRuleDetail().then((resp) => {
        let result = resp || {}
        const ancestors = result.ancestors || []
        this.updateCategoryId({
          categoryId: ancestors.length && ancestors[0].categoryId,
          childCategoryId: ancestors.length && ancestors[ancestors.length - 1].categoryId,
        })
        this.$emit('loadData')
        // setTimeout(() => {
        //   this.$emit('loadSy')
        // }, 200)
      }).catch(() => {
        this.error = true
      }).finally(() => {
        this.loading = false
      })
    },
    moment (val) {
      if (!val) {
        return '-'
      }
      return moment(val).format('YYYY年MM月DD日')
    },
    download1 () {
      if (this.pdfUrl) {
        let $a = document.createElement('a');
        $a.setAttribute('href', this.pdfUrl);
        // $a.setAttribute('download', `${this.title}-${this.moment(this.operationTimestamp)}.jpeg`);
        let fileLink = document.createElement('span')
        fileLink.setAttribute('style', 'cursor: pointer; -webkit-tap-highlight-color: transparent');
        $a.appendChild(fileLink)
        let body = document.getElementsByTagName('body')[0]
        body.appendChild($a)
        fileLink.click()
        body.removeChild($a)
        // return window.open(this.pdfUrl, '_blank')
      } else {
        return this.$message.warning('当前规则无PDF文件供下载')
      }
    },
    download () {
      // if (this.pdfUrl) {
      //   return window.open(this.pdfUrl, '_blank')
      // }
      this.downloadIng = true
      this.$emit('loadSy')
      // console.log(111, html2canvas, this.$refs.detailContainer.parentElement, jsPDF)
      setTimeout(() => {
        // this.$refs.detailContainer.parentElement
        html2canvas(document.getElementById('print'), {
          useCORS: true
        }).then((canvas) => {
          var contentWidth = canvas.width
          var contentHeight = canvas.height

          //一页pdf显示html页面生成的canvas高度;
          var pageHeight = contentWidth / 592.28 * 841.89
          //未生成pdf的html页面高度
          var leftHeight = contentHeight
          //页面偏移
          var position = 0
          //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
          var imgWidth = 595.28
          var imgHeight = 592.28/contentWidth * contentHeight

          var pageData = canvas.toDataURL('image/jpeg', 1.0)

          var pdf = new jsPDF('', 'pt', 'a4');

          //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
          //当内容未超过pdf一页显示的范围，无需分页
          if (leftHeight < pageHeight) {
            pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight )
          } else {
            while(leftHeight > 0) {
              pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
              leftHeight -= pageHeight
              position -= 841.89
              //避免添加空白页
              if(leftHeight > 0) {
                pdf.addPage()
              }
            }
          }
          pdf.save(`${this.title}-${this.moment(this.operationTimestamp)}.pdf`)
          this.downloadIng = false
          // document.body.appendChild(canvas)

          // var imgData = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
          // let $a = document.createElement('a');
          // $a.setAttribute('href', imgData);
          // $a.setAttribute('download', `${this.title}-${this.moment(this.operationTimestamp)}.jpeg`);
          // let fileLink = document.createElement('span')
          // fileLink.setAttribute('style', 'cursor: pointer; -webkit-tap-highlight-color: transparent');
          // $a.appendChild(fileLink)
          // let body = document.getElementsByTagName('body')[0]
          // body.appendChild($a)
          // fileLink.click()
          // body.removeChild($a)
          // this.$emit('hideSy')
          // console.log(111, canvas.width, canvas.height)
        })
      }, 0)
      // if (!this.pdfUrl) {
      //   return this.$message.warning('当前规则无PDF文件供下载')
      // }
    },
  },
  watch: {
    $route (newVal, oldVal) {
      console.log(111, newVal, oldVal)
      this.mountedFn()
    }
  },
  components: {
    viewContainer
  }
}
</script>

<style lang="scss" scoped>
.container  {
  position: relative;
}
// .container {
//     position: relative;
//     margin: 0;
//     font-weight: bold;
//     letter-spacing: -0.05rem;
//     line-height: 1;
//     text-transform: uppercase;
//     z-index: 10;
// }
// .container:before {
//     content: "2018/08";
//     font-family: monospace;
//     font-size: 12px;
//     position: absolute;
//     top: 2rem;
//     left: -2rem;
//     z-index: 0;
//     line-height: 1;
//     color: rgba(50, 25, 0, 0.1);
//     transform:rotate(-45deg);
// }
.title {
  font-size: 22px;
  color: #333333;
  font-weight: 500;
  line-height: 30px;
  border-bottom: 1px solid #E7E7E7;
  position: relative;
  padding: 10px 110px 10px 0px;
  padding-right: 76px;
  margin: 0;
  // word-break: break-all;
  word-wrap: break-word;
  white-space: normal;
  .date {
    display: block;
    font-size: 12px;
    color: #999;
    font-weight: 400;
    margin-top: 10px;
  }
  .download {
    background: #FBEEF2;
    border: 1px solid #FFBDE0;
    border-radius: 3px;
    font-size: 15px;
    color: #F10180;
    text-align: center;
    line-height: 15px;
    font-weight: 400;
    width: 70px;
    height: 32px;
    outline: none;
    position: absolute;
    top: 8px;
    right: 0;
  }
}
.content {
  padding: 30px 0;
  overflow: hidden;
  .info {
    all: initial;
    word-wrap: break-word;
    white-space: normal;
    :deep(video) {
      max-width: 100%!important;
      max-height: 100%!important;
    }
    :deep(img) {
      max-width: 100%!important;
      max-height: 100%!important;
    }
  }
}
.btn-download {
  background: #FBEEF2;
  border: 1px solid #FFBDE0;
  border-radius: 3px;
  font-size: 15px;
  color: #F10180;
  text-align: center;
  line-height: 32px;
  font-weight: 400;
  width: 70px;
  height: 32px;
  outline: none;
  position: absolute;
  top: 8px;
  right: 0;
}
</style>
